import Cookies from 'universal-cookie';

const postPresenceClockInResponse = ({ response, deviceId }) => {
  const cookies = new Cookies();
  const today = new Date();

  const expirationDate = new Date(today.setMonth(today.getMonth() + 1));

  cookies.set('deviceId', deviceId, { expires: expirationDate, path: '/' });

  return response;
};

export default postPresenceClockInResponse;
